document.addEventListener('DOMContentLoaded', function() {
  const featuredMessagesElement = document.querySelector('.featured-messages-swiper');
  
  if (featuredMessagesElement) {
    const featuredMessagesSwiper = new Swiper('.featured-messages-swiper', {
      slidesPerView: 'auto',
      spaceBetween: 20,
      loop: false,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      speed: 800,
      grabCursor: true,
      centeredSlides: false,
      breakpoints: {
        // Tablet - slides automáticos
        768: {
          slidesPerView: 'auto',
          spaceBetween: 30,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          }
        },
        // Desktop até 1300px - slides automáticos com espaço
        1024: {
          slidesPerView: 'auto',
          spaceBetween: 15,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          }
        },
        // Desktop acima de 1300px - slides automáticos sem espaço
        1300: {
          slidesPerView: 'auto',
          spaceBetween: 0,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          }
        }
      },
      on: {
        init: function() {
          // Adiciona classe quando o Swiper é inicializado
          featuredMessagesElement.classList.add('swiper-initialized');
        }
      }
    });
  }
}); 